<template>
    <section class="bg-01173E">
        <CContainer>
            <section class="why-section py-5 text-center text-light">
    
                <div class="spotlight-container">
                    <div class="spotlight"></div>
                    <h2 class="section-title font-Montserrat">Featured Learning Material</h2>
                </div>
            </section>
    
            <CRow>
  <CCol md="4" v-for="(img, index) in flatImages" :key="index" class="mb-4">
    <img :src="img" style="width: 100%; height: auto;" />
  </CCol>
</CRow>
    
    
            <section class="why-section py-5 text-center text-light">
    
                <div class="spotlight-container">
                    <div class="spotlight"></div>
                    <h2 class="section-title font-Montserrat">Featured Combo Courses</h2>
                </div>
            </section>
    
            <CRow>
                <!-- First image - takes 8 columns -->
                <CCol md="4" v-for="(column, colIndex) in imageColumnsCombo" :key="colIndex" class="mb-4">
                    <div v-for="(img, imgIndex) in column" :key="imgIndex" class="mb-4">
                        <img :src="img" style="max-width: 100%; height: auto;" />
                    </div>
                </CCol>
            </CRow>
    
            <section class="why-section py-5 text-center text-light">
    
                <div class="spotlight-container">
                    <div class="spotlight"></div>
                    <h2 class="section-title font-Montserrat">Featured Solo Courses</h2>
                </div>
            </section>
    
            <CRow>
                <!-- First image - takes 8 columns -->
                <CCol md="4" v-for="(column, colIndex) in imageColumnsSolo" :key="colIndex" class="mb-4">
                    <div v-for="(img, imgIndex) in column" :key="imgIndex" class="mb-4">
                        <img :src="img" style="max-width: 100%; height: auto;" />
                    </div>
                </CCol>
            </CRow>
        </CContainer>
    </section>
</template>
  
<script>
export default {
    data() {
        return {
            imageColumns: [
                [require('@/assets/img/flyhigh/f4.png'), require('@/assets/img/flyhigh/f5.png'),require('@/assets/img/flyhigh/f6.png')],
            ],
            imageColumnsCombo: [
                [require('@/assets/img/flyhigh/fc1.png'), require('@/assets/img/flyhigh/fc4.png')],
                [require('@/assets/img/flyhigh/fc2.png'), require('@/assets/img/flyhigh/fc5.png')],
                [require('@/assets/img/flyhigh/fc3.png'), require('@/assets/img/flyhigh/fc6.png')],
            ],
            imageColumnsSolo: [
                [require('@/assets/img/flyhigh/fs1.png'), require('@/assets/img/flyhigh/fs4.png')],
                [require('@/assets/img/flyhigh/fs2.png'), require('@/assets/img/flyhigh/fs5.png')],
                [require('@/assets/img/flyhigh/fs3.png'), require('@/assets/img/flyhigh/fs6.png')],
            ]
        }
    },
    computed: {
  flatImages() {
    return this.imageColumns.flat();
  }
}
}
</script>